<app-loader [loadingState]="loadingState$ | async" relativeWidthAndHeight="true" class="w-full h-full"></app-loader>
<div class="p-4 flex items-center justify-between border-b border-grey-concrete">
  <h2 class="font-medium text-lg text-grey-blue">Add Next Step</h2>
  <button
    id="close-modal-button"
    class="btn-primary m-0 flex items-center justify-center w-min p-1"
    (click)="closePopover()"
  >
    <ion-icon class="h-5 w-5" name="close-outline"></ion-icon>
  </button>
</div>
<app-next-step-form class="px-4 mt-2" [nextStepForm]="nextStepForm"></app-next-step-form>
@if ((loadingState$ | async) === 'loaded') {
  <div id="action-footer-popover" class="mt-2">
    <footer class="flex gap-2 px-3 py-2 w-full border-t-2 border-grey-concrete">
      <button id="create-next-step" class="btn-primary text-sm" (click)="createNextStep()">Save</button>
      <button id="cancel-create-next-step" class="btn-default text-sm" (click)="closePopover()">Cancel</button>
    </footer>
  </div>
}
